// extracted by mini-css-extract-plugin
export default {"logoSection":"LogoSection_logoSection__1ze8b","valueSection":"LogoSection_valueSection__1-fRp","label":"LogoSection_label__1HSDx"};